import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class AppChromeService {
  hideAppChrome: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  showChrome(): void {
    this.hideAppChrome.emit(false);
  }

  hideChrome(): void {
    this.hideAppChrome.emit(true);
  }
}
